import gql from 'graphql-tag';

export const DELETE_CUSTOM_MEASURE = gql`
  mutation DeleteCustomMeasure($tenantId: Int!, $measureId: Int!) {
    deleteCustomMeasure(input: { tenantId: $tenantId, measureId: $measureId }) {
      success
    }
  }
`;
